import React from "react";

export default () => {
    return <div className="preloader-background">
        <div className="spinner-grow"></div>
    </div>
}
